<template>
    <div>
        <div class="breadcrumb-section jarallax pixels-bg" data-jarallax data-speed="0.6">
            <div class="container text-center">
                <h1>NOS SERVICES</h1>
                <ul>
                    <li><router-link to="/">Accueil</router-link></li>
                    <li><a href="javascript:void(0);">Nos services</a></li>
                </ul>
            </div>
        </div>
        <div class="section-block">
            <div class="container">
                <div class="row mt-40" v-if="services != null">
                    <div class="col-md-4 col-sm-12 col-12" v-for="(service, index) in services" :key="index">
                        <div class="service-block-2">
                            <img :src="url + '/' + service.image" alt="" style="width:650;heigth:500;">
                            <div class="service-block-2-content">
                                <h4>
                                  <router-link :to="'/service/' + service.slug">{{ service.name }}</router-link>
                                </h4>
                                <strong v-short-description="{htmlText: service.description, count: 80}"></strong>
                                <router-link :to="'/service/' + service.slug" class="service-block-2-btn">
                                  Détails <i class="fa fa-arrow-right primary-color"></i>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-40" v-else>
                    <div class="col-md-12">
                        <div class="alert alert-info">
                            Chargement en cours ...
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from '../../config/urls'
export default {
  name: 'OurServices',
  data () {
    return {
      services: null,
      url: BASE_URL
    }
  },
  mounted () {
    this.getServices()
  },
  methods: {
    getServices () {
      let url = BASE_URL + API_PREFIX + API_VERSION + '/services'
      this.$http.get(url)
        .then((response) => {
          this.services = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/OurServices.vue